"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NTPIdentity = void 0;
var react_1 = __importDefault(require("react"));
var rgbColor = function (color) {
    var r, g, b, hsp;
    if (color === null || color === void 0 ? void 0 : color.match(/^rgb/)) {
        var rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = parseInt(rgb[1]);
        g = parseInt(rgb[2]);
        b = parseInt(rgb[3]);
    }
    else {
        // If hex --> Convert it to RGB
        var hex = +("0x" + color.slice(1).replace(color.length < 5 ? /./g : '', "$&$&"));
        r = hex >> 16;
        g = (hex >> 8) & 255;
        b = hex & 255;
    }
    // HSP (Highly Sensitive Poo) equation
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    return { rgb: [r, g, b], hsp: hsp };
};
var differenceBetweenTwoColors = function (color1, color2) {
    var _a = rgbColor(color1).rgb, r1 = _a[0], g1 = _a[1], b1 = _a[2];
    var _b = rgbColor(color2).rgb, r2 = _b[0], g2 = _b[1], b2 = _b[2];
    var d = Math.sqrt(Math.pow(r2 - r1, 2) + Math.pow(g2 - g1, 2) + Math.pow(b2 - b1, 2));
    var p = d / Math.sqrt(Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2));
    return p;
};
var NTPIdentity = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#fff' : _b, _c = _a.version, version = _c === void 0 ? 'vertical' : _c, secret = _a.secret;
    var contrast1 = differenceBetweenTwoColors(color, "#EB001B") < 0.25;
    var contrast2 = differenceBetweenTwoColors(color, "#F79E1B") < 0.25;
    var contrastRatio = contrast1 || contrast2;
    var logoColor;
    var parentBgColor;
    // Calculate logoColor and parentcolor based on the background color
    var hspValue = rgbColor(color).hsp;
    if (hspValue > 166) {
        logoColor = "black";
        parentBgColor = "#ffffff80";
    }
    else {
        logoColor = "white";
        parentBgColor = "#00000080";
    }
    var image = "https://mny.ro/np-".concat(logoColor, "-").concat(version === "vertical" ? 1 : 0, ".svg?id=").concat(secret);
    return (react_1.default.createElement("div", { style: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: version === "vertical" ? "150px" : "250px",
            maxHeight: version === "vertical" ? "100px" : "50px",
            backgroundColor: contrastRatio ? parentBgColor : "transparent",
        } }, secret ? (react_1.default.createElement("img", { src: image, alt: "NETOPIA Payments", title: "NETOPIA Payments", style: { width: "100%", height: "100%", cursor: "pointer" }, onClick: function () { return window.open("https://netopia-payments.com/", "_blank"); } })) : (react_1.default.createElement("div", null,
        "Missing",
        " ",
        react_1.default.createElement("span", { style: { fontWeight: "500", fontStyle: "italic" } }, "secret")))));
};
exports.NTPIdentity = NTPIdentity;
exports.default = NTPIdentity;
